module.exports = __webpack_public_path__ + "static/media/03-13.787e92f3.png";